import { Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { openSnack } from "../redux/GlobalStates";
export default function SimpleSnackbar() {
  const dispatch = useDispatch();
  const { snackbarOpen, snackbarMessage } = useSelector(
    (state) => state.globalStates
  );
  const close = () => dispatch(openSnack());
  return (
    <div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={close}
        message={snackbarMessage}
      />
    </div>
  );
}
